import React from 'react';
import PropTypes from 'prop-types';
import {
  Tooltip,
  withStyles,
} from '@material-ui/core';

import { hintStyles } from './HintStyles';

const propTypes = {
  classes: PropTypes.object.isRequired,
};

const Hint = (props) => (
  <Tooltip
    { ...props }
    classes={{
      tooltip: props.classes.tooltip,
      popper: props.classes.popper,
    }}
  />
);

Hint.propTypes = propTypes;

export default withStyles(hintStyles)(Hint);
